import { computed } from 'vue';

export const IS_DEMO_MODE = stringToBoolean(import.meta.env.VITE_APP_DEMO_MODE);

function stringToBoolean(str) {
  if (typeof str !== 'string') return false;
  return str.toLowerCase() === 'true';
}

export const WEBSOCKET_PING_INTERVAL = Number(import.meta.env.VITE_APP_WEBSOCKET_PING_INTERVAL) || 50000; // 50sec
export const WEBSOCKET_KEEP_ALIVE = Number(import.meta.env.VITE_APP_WEBSOCKET_KEEP_ALIVE) || 9000000; // 15min

export const apiDomain = import.meta.server ? import.meta.env.VITE_NUXT_BACKEND_API_URL : import.meta.env.VITE_APP_API_URL;

export const websocketDomain = apiDomain.replace('https://', 'wss://').replace('http://', 'ws://');

export const TEMPORARY_DISABLED = true;

export const STATE_LOGIN_INITIAL = 0;
export const STATE_LOGIN_INITIAL_LOADING = 10; // IT'S GOOD IDEA TO ADD NEW STATES ID?

export const STATE_LOGIN_WELCOME = 1;
export const STATE_LOGIN_WELCOME_LOADING = 11; // IT'S GOOD IDEA TO ADD NEW STATES ID?

export const STATE_LOGIN_EMAIL_CHECKING = 2;
export const STATE_LOGIN_EMAIL_SUCCESS = 3;
export const STATE_LOGIN_EMAIL_FAIL = 4;
export const STATE_LOGIN_EMAIL_RESEND = 5;
export const STATE_LOGIN_PASSWORD_ASK = 6;
export const STATE_LOGIN_PASSWORD_CHECKING = 7;
export const STATE_LOGIN_PASSWORD_FORGOT = 13;
export const STATE_LOGIN_PASSWORD_SUCCESS = 8;
export const STATE_LOGIN_PASSWORD_FAIL = 9;

export const VIDEO_ENGINEERS_CATEGORIES_IDS = [ 1 ];
export const GRAPHIC_CATEGORIES_IDS = [ 2 ];
export const THREE_D_CATEGORIES_IDS = [ 3 ];
export const ARCHiTECTS_ENGINEERS_IDS = [ 4 ];

export const TOTP_DEVICE_NAME = 'Aristeem';

export function useProgramSlides(t) {
  return [
    {
      title: t('libraryPage.banner.selectedForDesigners'),
      description: t('libraryPage.banner.desc1'),
      imgUrl: 'https://cdn.aristeem.com/images/3D+max/2.png',
      videoUrlMp4: 'https://d9usr6i0h5fem.cloudfront.net/public/video_1_opt.mp4',
      videoUrlWebM: 'https://d9usr6i0h5fem.cloudfront.net/public/video_1_opt.webm',
      to: `/category/${GRAPHIC_CATEGORIES_IDS[0]}`
    },
    {
      title: t('libraryPage.banner.selectedFor3dArtists'),
      description: t('libraryPage.banner.desc2'),
      imgUrl: 'https://cdn.aristeem.com/images/Adobe+premiere+pro/2.webp',
      videoUrlMp4: 'https://d9usr6i0h5fem.cloudfront.net/public/video_2_opt.mp4',
      videoUrlWebM: 'https://d9usr6i0h5fem.cloudfront.net/public/video_2_opt.webm',
      to: `/category/${THREE_D_CATEGORIES_IDS[0]}`
    },
    {
      title: t('libraryPage.banner.selectedForVideoMakers'),
      description: t('libraryPage.banner.desc3'),
      imgUrl: 'https://cdn.aristeem.com/images/Adobe+Illustrator+2024/2.png',
      videoUrlMp4: 'https://d9usr6i0h5fem.cloudfront.net/public/video_3_opt.mp4',
      videoUrlWebM: 'https://d9usr6i0h5fem.cloudfront.net/public/video_3_opt.webm',
      to: `/category/${VIDEO_ENGINEERS_CATEGORIES_IDS[0]}`
    }
  ];
}

export function useFastCategoryFilters(t) {
  return [
    { label: t('libraryPage.all'), ids: [ 999 ] },
    { label: t('libraryPage.videoEngineers'), ids: VIDEO_ENGINEERS_CATEGORIES_IDS },
    { label: t('libraryPage.graphic'), ids: GRAPHIC_CATEGORIES_IDS },
    { label: t('libraryPage.3d'), ids: THREE_D_CATEGORIES_IDS },
    { label: t('libraryPage.architectsAndEngineers'), ids: ARCHiTECTS_ENGINEERS_IDS }
  ];
}

export function useLicenseTypes(t) {
  return [
    { name: t('libraryPage.all'), value: 'all' },
    { name: t('libraryPage.free'), value: 'free' },
    { name: t('libraryPage.paid'), value: 'paid' }
  ];
}

export const MAX_SIZE_UPLOAD_FILE = 5 * 1024 * 1024;
export const ALLOWED_FORMATS_TO_UPLOAD = [ 'image/png', 'image/jpeg', 'image/webp' ];
export const AUTH_DIGITS_COUNT = 6;
export function useDeleteAccountReasons(t) {
  return [
    {
      title: t('myProfile.deleteAccount.negativeServiceExperience'),
      value: 'I have negative service experience'
    },
    {
      title: t('myProfile.deleteAccount.foundAlternative'),
      value: 'I found alternative'
    },
    {
      title: t('myProfile.deleteAccount.tooExpensive'),
      value: 'Your service is too expensive'
    },
    {
      title: t('myProfile.deleteAccount.canNotFindProgram'),
      value: 'I can’t find a program that I would like to'
    },
    {
      title: t('myProfile.deleteAccount.other'),
      value: 'Other'
    }
  ];
}

export const IMAGE_SIZES = [ 280, 560, 840, 1120, 1400, 1680 ];

export const LANDING_PAGE = 'https://aristeem.com';

export const PRIVACY = 'https://web-staging-content.s3.eu-central-1.amazonaws.com/public/docs/privacy.pdf';
export const TERMS = 'https://web-staging-content.s3.eu-central-1.amazonaws.com/public/docs/terms.pdf';
export const COOKIE = 'https://web-staging-content.s3.eu-central-1.amazonaws.com/public/docs/cookie.pdf';

export function useSortedCategories(t) {
  return computed(() => [
    {
      name: 'All',
      label: t('filters.all')
    },
    {
      name: '3D',
      label: t('filters.3D')
    },
    {
      name: 'Graphics',
      label: t('filters.graphics')
    },
    {
      name: 'Architecture & Engineering',
      label: t('filters.architectureEngineering')
    },
    {
      name: 'Video & Motion',
      label: t('filters.videoMotion')
    },
    {
      name: 'Game Development',
      label: t('filters.gameDevelopment')
    },
    {
      name: 'Data Analytics',
      label: t('filters.dataAnalytics')
    },
    {
      name: 'Audio & Music',
      label: t('filters.audioMusic')
    },
    {
      name: 'Productivity',
      label: t('filters.productivity')
    },
    {
      name: 'Publishing',
      label: t('filters.publishing')
    },
    {
      name: 'Simulation',
      label: t('filters.simulation')
    }
  ]);
}

export function useArraySortBy(t) {
  return [
    { id: 0, name: t('sortBy.popular'), value: 'namePopular' },
    { id: 1, name: t('sortBy.asc'), value: 'nameAsc' },
    { id: 2, name: t('sortBy.desc'), value: 'nameDesc' }
  ];
}

export const LANGUAGES = [
  { name: 'EN English', value: 'en' },
  { name: 'ES Español', value: 'es' },
  { name: 'SK Slovák', value: 'sk' },
  { name: 'RO Română', value: 'ro' },
  { name: 'PL Polski', value: 'pl' },
  { name: 'HU Magyar', value: 'hu' },
  { name: 'DE Deutsch', value: 'de' },
  { name: 'CZ Česká', value: 'cz' }
];

export const FILES_BLACKLIST = [
  '$RECYCLE.BIN'
];
